import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import useStyles from './styles'

const MaxLengthMessage = ({ length, maxLength }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <div className={classes.maxLengthMessage}>
      {length} {t('of max.')} {maxLength || 400} {t('characters')}
    </div>
  )
}

MaxLengthMessage.propTypes = {
  length: PropTypes.number,
  maxLength: PropTypes.number
}

export default MaxLengthMessage
